import axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { createAction } from 'redux-act';
import { errorMsg } from 'utils';
import { url } from 'utils/url';

export const MEDIA_CALENDAR_SUCCESS = createAction('MEDIA_CALENDAR_SUCCESS');

export const MEDIA_CALENDAR_LOADING = createAction('MEDIA_CALENDAR_LOADING');

export const fetchMediaCalendar = ({
  siteId,
  start,
  end,
  screenId,
  categoryId,
  signal,
}) => {
  return async (dispatch) => {
    try {
      const params = {
        siteId,
        start,
        end,
      };

      if (screenId) {
        params.screenId = screenId;
      }

      if (categoryId) {
        params.categoryId = categoryId;
      }

      const response = await axios.get(`${url}/media/calendar`, {
        params,
        signal,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });

      // No reducer handles MEDIA_CALENDAR_*; dispatching them only pushed the
      // whole calendar payload through every store subscriber. The component
      // owns this data via the returned value.
      return response.data;
    } catch (error) {
      // A superseded request is not a failure - the caller aborted it on
      // purpose, so it must not surface as a toast.
      if (axios.isCancel(error) || error.name === 'CanceledError') {
        throw error;
      }

      toastr.error('', errorMsg(dispatch, error));
      throw error;
    }
  };
};